
import GpsCommonModal from 'components/common/GpsCommonMOdal/GpsCommonModal'
import React from 'react'

const GpsIntigrationModal = (props) => {

     
  return (
    <GpsCommonModal {...props} >
         </GpsCommonModal>
  )
}

export default GpsIntigrationModal